import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  FormHelperText,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { Add } from "@mui/icons-material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { DataGrid } from "@mui/x-data-grid";
import WaitingDialog from "../../utils/WaitingDialog";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  archivos: [],
  nombre_documentos: [],
};

const nameItemText = "Fotos";
//
// ########################################################################### 
//
const FotoDialog = ({ onSave, onClose, arrayFotos, actionCrud }) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const columns = [
    {
      field: "preview",
      headerName: "Preview",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        if (!params.row.archivo) return null;
        try {
          return (
            <Box
              sx={{
                width: 80,
                height: 80,
                display: 'flex',
                alignItems: "center",
                justifyContent: "center",
                overflow: 'hidden',
                borderRadius: "5px",
                backgroundColor: '#f5f5f5',
              }}
            >
              <img
                src={URL.createObjectURL(params.row.archivo)}
                alt="preview"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: "contain",
                  display: "block"
                }}
              />
            </Box>
          );
        } catch (error) {
          return (
            <Box
              sx={{
                width: 80,
                height: 80,
                display: 'flex',
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5px",
                backgroundColor: '#f5f5f5',
              }}
            >
              <span>Error</span>
            </Box>
          );
        }
      },
    },
    {
      field: "nombre",
      headerName: "Nombre del Archivo",
      flex: 1,
      minWidth: 200,
      sortable: false,
    },
    {
      field: "tipo",
      headerName: "Tipo",
      width: 150,
      sortable: false,
      renderCell: (params) => params.row.archivo?.type || params.row.tipo || '',
    },
    ...(actionCrud !== "view" ? [{
      field: "acciones",
      headerName: "Acciones",
      width: 120,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title="Quitar Elemento">
          <IconButton onClick={() => handleRemoveFile(params.row.index)}>
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      ),
    }] : []),
  ];

  const data = (itemCrudLocal?.archivos && Array.isArray(itemCrudLocal.archivos) && itemCrudLocal.archivos.length > 0)
    ? itemCrudLocal.archivos.map((archivo, index) => ({
      id: index,
      index: index,
      archivo: archivo,
      nombre: archivo?.name || archivo?.nombre || '',
      tipo: archivo?.type || archivo?.tipo || '',
    }))
    : [];

  const options = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
        display: 'flex',
        alignItems: "center",
        padding: '8px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
      '& .MuiDataGrid-row': {
        minHeight: '80px !important',
        maxHeight: '80px !important',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      },
      '& .MuiDataGrid-cell[data-field="preview"]': {
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
        padding: '8px',
        overflow: 'hidden',
      },
      maxHeight: '400px',
      overflow: 'auto',
    },
  };
  //
  // ########################################################################### 
  //
  useEffect(() => {
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(arrayFotos || initialState);
    }
  }, [actionCrud, arrayFotos]);
  //
  // ########################################################################### 
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ########################################################################### 
  //
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (!files.length) {
      setErrors((prev) => ({ ...prev, archivos: "Debe seleccionar al menos un archivo" }));
      return;
    }

    // Validar límite de 10 archivos
    const totalArchivos = itemCrudLocal.archivos.length + files.length;
    if (totalArchivos > 10) {
      setErrors((prev) => ({
        ...prev,
        archivos: `Solo se pueden seleccionar hasta 10 archivos. Actualmente tienes ${itemCrudLocal.archivos.length} y estás intentando agregar ${files.length}`,
      }));
      return;
    }

    const invalidFiles = files.filter(
      (file) =>
        file.size > 5 * 1024 * 1024 ||
        !["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(file.type)
    );

    if (invalidFiles.length > 0) {
      setErrors((prev) => ({
        ...prev,
        archivos: "Algunos archivos no son válidos ( menores a 5MB)",
      }));
      return;
    }

    setIsUploading(true);

    // Simular proceso de carga
    setTimeout(() => {
      setIsUploading(false);
      setItemCrudLocal((prev) => {
        const nuevosArchivos = [...prev.archivos, ...files];
        return {
          ...prev,
          archivos: nuevosArchivos,
          nombre_documentos: nuevosArchivos.map((f) => f.name),
        };
      });
      setErrors((prevErrors) => {
        const { archivos, ...rest } = prevErrors;
        return rest;
      });
    }, 2000);
  };

  const handleRemoveFile = (index) => {
    const nuevosArchivos = [...itemCrudLocal.archivos];
    nuevosArchivos.splice(index, 1);
    setItemCrudLocal({
      archivos: nuevosArchivos,
      nombre_documentos: nuevosArchivos.map((f) => f.name),
    });
  };
  //
  // ########################################################################### 
  //
  const handleSave = () => {
    if (actionCrud === "view") return;

    const currentErrors = {};

    if (!itemCrudLocal.archivos || itemCrudLocal.archivos.length === 0) {
      currentErrors.archivos = "Debe seleccionar al menos un archivo";
    }

    if (Object.keys(currentErrors).length > 0) {
      setErrors(currentErrors);
      return;
    }

    const archivosConId = itemCrudLocal.archivos.map((archivo) => ({
      id_s3: uuidv4(),
      archivo,
      nombre: archivo.name,
    }));

    setIsDoingSomething(true);
    setTimeout(() => {
      setIsDoingSomething(false);
      onSave(archivosConId, actionCrud);
    }, 1000);
    setItemCrudLocal(initialState);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle sx={{ position: "relative" }}>
          Agregar {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <input
                accept="image/jpg, image/png, image/jpeg, image/webp"
                id="upload-file"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
                disabled={actionCrud === "view" || isUploading || itemCrudLocal.archivos.length >= 10}
                multiple
              />
              <label htmlFor="upload-file">
                <Button variant="contained" component="span" fullWidth disabled={isUploading || itemCrudLocal.archivos.length >= 10}>
                  {isUploading ? "Subiendo..." : itemCrudLocal.archivos.length >= 10 ? "Límite alcanzado (10 archivos)" : "Seleccionar archivos"}
                </Button>
              </label>

              <FormHelperText error>{errors.archivos || ""}</FormHelperText>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Archivos Seleccionados ({itemCrudLocal?.archivos?.length || 0}/10)
              </Typography>
              <Box sx={{ width: "100%", height: "400px", overflow: "hidden" }}>
                <DataGrid
                  rows={data}
                  columns={columns}
                  {...options}
                  sx={{ width: "100%", height: "100%" }}
                />
              </Box>
            </Grid>
          </Grid>

          {actionCrud !== "view" && (
            <Box sx={{ mt: 1 }}>
              <Grid container justifyContent="flex-end" spacing={1} sx={{ mt: 0 }}>
                <Button
                  variant="contained"
                  sx={{ mr: 1 }}
                  color="primary"
                  size="small"
                  startIcon={<Add />}
                  onClick={handleSave}
                  disabled={isDoingSomething || isUploading || itemCrudLocal.archivos.length === 0}
                >
                  {isDoingSomething ? "Guardando..." : "Agregar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                  startIcon={<CloseIcon />}
                >
                  Cerrar
                </Button>
              </Grid>
            </Box>
          )}
        </DialogContent>
      </Dialog >

      <WaitingDialog open={isDoingSomething || isUploading} />
    </>
  );
};
export default FotoDialog;
